// extracted by mini-css-extract-plugin
module.exports = {"bg":"_3RG-p","inlineContent":"_322uF","pageWrapper":"_10HNf","innerBg":"_1p3eg"};